import { ThemeProvider } from "@mui/material/styles";

import MyTheme from "../MyTheme";
import Welcome from "../pages/Welcome";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Home from "../pages/Home";
import CourseHome from "../pages/CourseHome";
import Init from "../pages/Init";
import Activate from "../pages/Activate";
import RecoveryPasword from "../pages/RecoveryPasword";
import Update from "../pages/Update";
import LoginAdmin from "../pages/Admin/Login";
import DashboardAdmin from "../pages/Admin/Dashboard";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { baseName } from '../constants'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const authState = useSelector((state: any) => state.auth);
  const location = useLocation();
  if (!authState.isAuthenticated || !authState.user) {
    return <Navigate to="/" replace state={{ path: location.pathname }} />;
  }
  return children;
}

function ProtectedRouteAdmin({ children }: { children: React.ReactNode }) {
  const authState = useSelector((state: any) => state.auth);
  const location = useLocation();
  
  // Verificar que sea admin y tenga un rol válido
  if (!authState.isAuthenticated ||
    !authState.user ||
    !authState.user?.isAdmin ||
    !authState.user?.rol?.clave
  ) {
    return <Navigate to="/login-admin" replace state={{ path: location.pathname }} />;
  }
  return children;
}

const RouteApp = () => {
  return (
    <ThemeProvider theme={MyTheme}>
      <BrowserRouter basename={baseName}>
        <Routes>
          <Route
            path="/"
            element={
              <div className="background-login">
                {" "}
                <Login />
                <Outlet />
              </div>
            }
          />

          <Route path="/welcome" element={<Welcome />} />
          <Route
            path="/activation"
            element={
              <ProtectedRoute key={"activation"}>
                <Activate />
                <Outlet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/login"
            element={
              <div className="background-login">
                {" "}
                <Login />
                <Outlet />
              </div>
            }
          />
          <Route
            path="/recovery"
            element={
              <div className="background-login">
                <RecoveryPasword />
              </div>
            }
          />
          <Route
            path="/register"
            element={
              <div className="background-login">
                <Register />
              </div>
            }
          />
          <Route
            path="/home"
            element={
              <ProtectedRoute key={"home"}>
                <Home />
                <Outlet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/:courseCode"
            element={
              <ProtectedRoute key={"course"}>
                <CourseHome />
                <Outlet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update"
            element={
              <ProtectedRoute key={"update"}>
                <Update />
                <Outlet />
              </ProtectedRoute>
            }
          />

          {/* Admin */}
          <Route
            path="/login-admin"
            element={
              <div className="background-login-admin">
                {" "}
                <LoginAdmin />
                <Outlet />
              </div>
            }
          />
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRouteAdmin>
                <DashboardAdmin />
              </ProtectedRouteAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default RouteApp;
